import { ChangeDetectorRef, Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { firstValueFrom, Subscription } from 'rxjs';
import { CaseFormsService } from '../case-forms.service';
import { Globals } from '../../../globals';
import { MessagingService } from '../../../services/messaging.service';
import { Router } from '@angular/router';
import { ARService } from '../../ar/ar.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { CaseAddProcedureComponent } from '../case-add-procedure/case-add-procedure.component';
import { CreateTransactionItemModel } from '../../../models/accountsReceivable/create-transaction-item.model';
import { DataPatientCaseWorkItemModel } from '../../../models/accountsReceivable/data-patient-case-work-item.model';
import { DataPatientCaseWorkItemToothModel } from '../../../models/teeth/data-patient-case-work-item-tooth.model';
import { EnumValidValueItemModel } from '../../../models/enum/enum-valid-value-item.model';
import { StaticDataService } from '../../../services/static-data.service';
import { CaseWorkItemStatusEnum } from '../../../models/enum/case-work-item-status.enum';
import { DataPatientCaseWorkItemFormToothModel } from '../../../models/teeth/data-patient-case-work-item-form-tooth.model';
import { CaseItemFormRemoveCancelComponent } from '../case-item-form-remove-cancel/case-item-form-remove-cancel.component';
import { CaseProcedureAddFormComponent } from '../case-procedure-add-form/case-procedure-add-form.component';
import { ToothPickerComponent } from '../../tdo-shared/tooth-picker/tooth-picker.component';
import { cfgTooth } from '../../tdo-shared/tooth-picker/tooth-picker.models';
import { ToothUiManagerModel } from '../../tdo-shared/tooth-picker/tooth-ui-manager/tooth-ui-manager.model';
import { PatientCaseWorkItemFormDataModel } from '../../../models/forms/data/patient-case-work-item-form-data.model';
import { NotesService } from '../../../services/notes.service';
import { TdoNoteQueryModel } from '../../../main-interface/controls/tdo-notes/models/tdo-note-query.model';
import { MessagingConstants } from '../../../models/MessagingConstants';
import { DoctorByTDOCIDModel } from '../../ar/models/doctor-by-tdocid.model';
import { PassedPatientCaseWorkItemEventModel } from '../models/passed-patient-case-work-item-event';
import { DataPatientCaseWorkItemEventModel } from '../../../models/accountsReceivable/data-patient-case-work-item-event';
import { LocalStorageService } from '../../../services/local-storage.service';
import { ToothService } from '../../../services/tooth.service';
import { UiService } from '../../../services/ui.service';
import { AuthenticationService } from '../../auth/services/authentication.service';
import { UserRoleEnum } from '../../../models/enum/user-role.enum';
import { ToothPickerConfigModel } from '../../tdo-shared/tooth-picker/tooth-picker-config.model';
import { ToothConfigurationModel } from '../../../models/teeth/tooth-configuration.model';
import { TdoDropdownChange } from '../../../tdo-controls/common/tdo-dropdown-v2/models/tdo-dropdown-change';
import { SchedulingService } from '../../scheduling/scheduling.service';
import { DataAppointmentModel } from '../../../models/appointments/data-appointment.model';
import { SignalrService } from '../../../services/socket/signalr.service';
import {
    CaseViewWorkItemEventsDialogComponent
} from './dialog/case-view-work-item-events-dialog/case-view-work-item-events-dialog.component';
import {
    CaseViewPatientFormsDetailsDialogComponent
} from './dialog/case-view-patient-forms-details-dialog/case-view-patient-forms-details-dialog.component';
import { DialogService } from '../../../services/dialog.service';
import { FormsGlobals } from 'src/app/models/forms/forms.enum';
import { CaseBillFunctionalityComponent } from '../case-bill-functionality/case-bill-functionality.component';
import { VitalSignsDialogComponent, VitalSignsModel } from '../../../dialog/vital-signs-dialog/vital-signs-dialog.component';
import { MedicalHistoryService } from 'src/app/services/form/medical-history.service';
import { ReferringDoctorInformationComponent } from '../../referring-doctors/referring-doctor-information/referring-doctor-information.component';
import { Constants } from 'src/app/constants';
import { DateRangeModel } from 'src/app/models/date-range.model';


@Component({
    standalone: false,
    selector: 'app-case-view',
    templateUrl: './case-view.component.html',
    styleUrls: ['./case-view.component.scss']
})
export class CaseViewComponent implements OnInit, OnDestroy {
    currentCaseWorkItem: DataPatientCaseWorkItemModel;
    currentCaseWorkItemForm: PatientCaseWorkItemFormDataModel;
    private _patientCaseId: string;
    private _isMinimizedByCheckOut: boolean;

    CaseInfo: any;
    patientMedicalAlerts: any[] = [];
    hasCriticalMedicalAlerts: boolean = false;
    currentUser: any;
    isCheckin: boolean = false;
    isLoadingInitialData: boolean = false;
    processedRefresh: boolean = false;
    refreshTimeout: any;
    private isActivelyLoadingCaseData: boolean = false;
    private loadDataRetryTimer: any = null;
    selectedDFormId: string | null = null;

    get patientCaseId(): string {
        return this._patientCaseId;
    }
    @Input()
    set patientCaseId(val: string) {
        if (this._patientCaseId !== val) {
            this.CaseInfo = null;
            this._patientCaseId = val;
            this.currentSelection = '';
            if (val != null && val != undefined && val != 'null' && val != 'undefined') {
                this.globals.currentPatientCaseWorkItemID = null;
                this.currentCaseWorkItemID = null;
                this.currentSelection = null;
                this.loadData(false);
            }
            else {
                this.caseWorkItems = [];
                this.caseWorkItemsPatientForms = [];
                this.CaseInfo = null;
                this.patientMedicalAlerts = [];
                this.hasCriticalMedicalAlerts = false;
                this.isCheckin = false;
                this.globals.currentPatientCaseWorkItemID = null;
                this.finishLoading();
            }
        }
        else {
            this.isLoading = false;
            this.cdr.detectChanges();
        }
    }
    get isMinimizedByCheckOut(): boolean {
        return this._isMinimizedByCheckOut;
    }

    @Input()
    set isMinimizedByCheckOut(val: boolean) {
        if (this._isMinimizedByCheckOut !== val) {
            this._isMinimizedByCheckOut = val;
        }
    }

    @Output() requestCheckOut = new EventEmitter();



    subscription: Subscription | null = null;

    enumCaseItemStatus: EnumValidValueItemModel[] = [];
    enumCaseItemFormStatus: EnumValidValueItemModel[] = [];
    enumCaseItemFormFilledBy: EnumValidValueItemModel[] = [];
    allTeeth: cfgTooth[] = [];
    isLoading: boolean = true;
    isDataLoadingLoop: boolean = false;
    isLoadingPatientForms: boolean = true;
    caseWorkItems: DataPatientCaseWorkItemModel[] = [];
    caseWorkItemsPatientForms: PatientCaseWorkItemFormDataModel[] = [];
    caseWorkItemsPatientFormsCaseWorkItemID: string;
    caseWorkItemsPatientFormsCaseWorkItem: DataPatientCaseWorkItemModel;
    appointment: DataAppointmentModel;
    currentCaseWorkItemID: string;
    currentCaseWorkItemFormID: string;
    currentSelection: string;
    allowToothPicker: boolean = false;
    currentSectionSelection: number = 1; // initially set to procedures section
    doctorsByTDOCID: DoctorByTDOCIDModel[] = [];
    activeDoctors: DoctorByTDOCIDModel[] = [];
    locationDoctors: DoctorByTDOCIDModel[] = [];
    activeLocationDoctors: DoctorByTDOCIDModel[] = [];
    private doctorDropdownOptionsCache = new Map<string, { assignedId: string; baseline: DoctorByTDOCIDModel[]; options: DoctorByTDOCIDModel[] }>();
    doctorDisabledPredicate: (data: DoctorByTDOCIDModel) => boolean = (data: DoctorByTDOCIDModel) => {
        return !data.isActiveDoctor;
    };

    caseWorkItemStatusPending = '00000167-1000-0000-0000-000000000001';
    caseWorkItemStatusComplete = '00000167-1000-0000-0000-000000000003';
    caseWorkItemStatusCancelled = '00000167-1000-0000-0000-000000000004';
    caseWorkItemStatusInProgress = '00000167-1000-0000-0000-000000000002';

    errors: any;
    messageSubscription: any;
    userIsDoctor: boolean = false;
    emptyGuid = Constants.emptyGuid;

    patientFormsMessage = 'No general forms added.';
    isShowPatientForms: boolean = false;
    isReloadingForms: boolean = false;

    showMoreCaseOptions: boolean = false;
    listOfMoreCaseOptions = [
        { name: 'Complete Case', id: 0 }, // just complete case
        { name: 'Bill', id: 1 }, // complete case first, then go to fees
        { name: 'Check Out', id: 2 }, // placehold for moises checkout component
    ];

    dataLoaded: boolean = false; // flag to wait for  collections loading before executing loadData() (this is causing things like doctor selection being empty because collection hastn't been loaded)
    constructor(
        private readonly signalrService: SignalrService,
        public globals: Globals,
        private readonly caseService: CaseFormsService,
        private readonly messagingService: MessagingService,
        private readonly router: Router,
        private readonly arService: ARService,
        private readonly dialog: MatDialog,
        private readonly staticDataService: StaticDataService,
        private readonly notesService: NotesService,
        private readonly localStorageService: LocalStorageService,
        private readonly toothService: ToothService,
        public uiService: UiService,
        private readonly authenticationService: AuthenticationService,
        private readonly schedulingService: SchedulingService,
        private readonly dialogService: DialogService,
        public formsGlobals: FormsGlobals,
        private readonly medicalHistoryService: MedicalHistoryService,
        private readonly cdr: ChangeDetectorRef
    ) { }

    private setEnums() {
        this.enumCaseItemStatus = this.staticDataService.getValidValueItemsByValidValueName('enumCaseWorkItemStatus');
        this.enumCaseItemFormStatus = this.staticDataService.getValidValueItemsByValidValueName('enumFormCompletionStatus');
        this.enumCaseItemFormFilledBy = this.staticDataService.getValidValueItemsByValidValueName('enumFormFilledBy');
        this.loadInitialData();
    }

    ngOnDestroy() {
        this.currentCaseWorkItemID = null;
        this.globals.currentPatientCaseWorkItemID = null;
        this.currentSelection = null;
        if (this.subscription) {
            this.subscription.unsubscribe();
            this.subscription = null;
        }
    }
    ngOnInit() {
        this.currentCaseWorkItemID = null;
        this.globals.currentPatientCaseWorkItemID = null;
        this.currentSelection = null;
        if (!this.authenticationService.isLoggedIn()) {
            return;
        }
        if (this.staticDataService.isReady && this.staticDataService.validValues && this.staticDataService.validValues.length > 0) {
            this.setEnums();
        } else {
            if (!this.staticDataService.validValues || this.staticDataService.validValues.length === 0) {
                this.staticDataService.refreshValues(true);
            }
            this.staticDataService.validValuesReadyEvent.subscribe({
                complete: () => {
                    this.setEnums();
                }
            });

            this.signalrService.messageUser.subscribe((message) => {
                switch (message.messageType) {
                    case 'PATIENT_FORMS_CREATION_START':
                        break;
                    case 'PATIENT_FORMS_CREATED':
                        break;
                    case MessagingConstants.CASES_REFRESH:
                        if (this.processedRefresh) {
                            return;
                        }
                        this.processedRefresh = true;
                        if (this.refreshTimeout) {
                            clearTimeout(this.refreshTimeout);
                            this.refreshTimeout = null;
                        }
                        this.refreshTimeout = setTimeout(() => {
                            this.processedRefresh = false;
                        }, 10000);
                        this.loadData(false);
                        break;
                }
            });
        }
        if (this.subscription) {
            this.subscription.unsubscribe();
            this.subscription = null;
        }

        this.subscription = this.messagingService.componentMessageCall.subscribe((response) => {
            const event = response.event;
            switch (event) {
                case MessagingConstants.PENDING_CASES_REFRESH_LIST_ONLY:
                    this.processedRefresh = true;
                    if (this.refreshTimeout) {
                        clearTimeout(this.refreshTimeout);
                        this.refreshTimeout = null;
                    }
                    this.refreshTimeout = setTimeout(() => {
                        this.processedRefresh = false;
                    }, 10000);
                    break;
                case MessagingConstants.CASES_REFRESH:
                case MessagingConstants.CASE_CHANGED_EVENT:
                case MessagingConstants.CASES_REFRESH_LIST_ONLY:
                    this.loadData(false, false, true);
                    break;
                case MessagingConstants.CASE_FORMS_REFRESH:
                case MessagingConstants.RELOAD_PATIENT_FORMS:
                    if (!this.isDataLoadingLoop) { this.reloadPatientForms(); }
                    break;
                case MessagingConstants.CASE_VIEW_COLLAPSE:
                    break;
                case MessagingConstants.CHECKOUT_PATIENT_START:
                    this.onCheckOutPatient();
                    break;
                case MessagingConstants.PATIENT_CHANGED:
                    this.dialogService.closeAllDialogs();
                    this.caseWorkItems = [];
                    this.caseWorkItemsPatientForms = [];
                    this.CaseInfo = null;
                    this.patientMedicalAlerts = [];
                    this.hasCriticalMedicalAlerts = false;
                    this.patientCaseId = null;
                    this.isCheckin = response.data.isCheckin;
                    this.selectedDFormId = null;
                    break;
                case MessagingConstants.FORM_COMPLETED: {
                    const form = this.caseWorkItemsPatientForms.find(f => f.CaseWorkItemFormsId == response.data.CaseWorkItemFormsId);
                    if (form) {
                        form.enumFormCompletionStatusID = this.formsGlobals.STATUS_COMPLETED;
                        form.Status = 'Completed/ Signed';
                        form.Completed = true;
                    }
                    break;
                }
            }
        });


    }

    async loadInitialData() {
        // get all enums
        this.globals.currentPatientId = this.globals.ThePatient?.PatientId;
        if (this.globals.currentPatientId !== 'null' && this.globals.currentPatientId !== 'undefined' && this.globals.currentPatientId !== null && this.globals.currentPatientId !== undefined) {
            this.isLoadingInitialData = true;
            const promises: any[] = [
                this.caseService.getTeeth('00000091-1000-0000-0000-000000000001').toPromise(), // US tooth grouping
                this.arService.getDoctorsByTDOCIDFees().toPromise(),
                this.caseService.getPatientFormsCaseWorkItem(this.globals.LOCID, this.globals.currentPatientId).toPromise(), // general patient forms caseWorkItem
                this.arService.getDoctorsByLOCID(Number.parseInt(this.globals.LOCID)).toPromise(), // Location doctors
            ];

            try {
                Promise.all(promises).then((results) => {
                    this.allTeeth = results[0];
                    if (results[1]) {
                        this.doctorsByTDOCID = results[1];
                        this.activeDoctors = this.doctorsByTDOCID.filter(p => p.isActiveDoctor);
                    }
                    if (results[2]) {
                        this.caseWorkItemsPatientFormsCaseWorkItem = results[2];
                        this.caseWorkItemsPatientFormsCaseWorkItemID = this.caseWorkItemsPatientFormsCaseWorkItem?.CaseWorkItemId;
                    }
                    if (results[3]) {
                        this.locationDoctors = results[3];
                        this.activeLocationDoctors = this.locationDoctors.filter(d => d.isActiveDoctor === true);
                    }
                    this.dataLoaded = true;
                    // is user a doctor?
                    const userId = this.localStorageService.currentUserData.authdata.userid;
                    const userDoctor = this.doctorsByTDOCID.find(a => a.UserId === userId);
                    if (userDoctor) {
                        this.userIsDoctor = true;
                    }
                    this.finishLoading();
                }).catch((err) => {
                    console.error('loading forms promise errror', err);
                    this.isLoadingInitialData = false;
                    this.showMessage('Error', 'Something went wrong');
                    this.finishLoading();
                });
            }
            catch (err) {
                console.error('loading forms error', err);
                this.isLoadingInitialData = false;
                this.showMessage('Error', 'Something went wrong');
                this.finishLoading();
            }
        }
        else {
            this.isLoadingInitialData = false;
            this.finishLoading();
        }
    }

    async reloadPatientForms() {
        if (this.isReloadingForms) {
            return;
        }

        this.isReloadingForms = true;
        this.isLoadingPatientForms = true;
        this.caseWorkItemsPatientForms = [];
        this.caseWorkItemsPatientFormsCaseWorkItemID = '';

        const promises: any[] = [
            this.caseService.getPatientForms(this.globals.currentPatientId).toPromise(), // general patient forms
            this.caseService.getPatientFormsCaseWorkItemID(this.globals.LOCID, this.globals.currentPatientId).toPromise() // general patient forms caseWorkItemID
        ];

        try {
            const results: any[] = await Promise.all(promises);

            if (results[0]) {
                const patientForms = results[0].sort((a, b) => a.formOrder - b.formOrder);
                for (const form of patientForms) {
                    form.toothList = this.returnToothListForForm(form.dataPatientCaseItemFormTeeth);
                }
                this.caseWorkItemsPatientForms = patientForms;
            }

            if (results[1]) {
                this.caseWorkItemsPatientFormsCaseWorkItemID = results[1];
            }

            this.isReloadingForms = false;
            this.finishLoading();
        } catch (err) {
            console.error('case view init forms reload error', err);
            this.isReloadingForms = false;
            this.finishLoading();
            this.showMessage('Error', 'Something went wrong');
        }
    }

    private finishLoading() {
        this.isLoading = false;
        this.isLoadingPatientForms = false;
        this.cdr.detectChanges();
    }

    isCurrentSelection(CaseWorkItemId: string, CaseWorkItemFormsId: string) {
        if (CaseWorkItemId && CaseWorkItemId !== '' && CaseWorkItemId === this.currentCaseWorkItemID) {
            return true;
        }
        else if (CaseWorkItemFormsId && CaseWorkItemFormsId !== '' && CaseWorkItemFormsId === this.currentSelection) {
            return true;
        }
        else {
            return false;
        }
    }

    setCurrentSelections(CaseWorkItemId: string, CaseWorkItemFormsId: string, loadNotes: boolean = true) {
        this.currentCaseWorkItem = this.caseWorkItems.find(p => p.CaseWorkItemId === CaseWorkItemId);
        if (this.currentCaseWorkItem !== undefined) {
            this.currentCaseWorkItemForm = this.currentCaseWorkItem.dataPatientCaseItemForms.find(p => p.CaseWorkItemFormsId.toLowerCase() === CaseWorkItemFormsId.toLowerCase());
        }
        this.currentCaseWorkItemFormID = CaseWorkItemFormsId;
        this.currentCaseWorkItemID = CaseWorkItemId;
        this.globals.currentPatientCaseWorkItemID = this.currentCaseWorkItemID;

        if (CaseWorkItemFormsId) {
            this.currentSelection = CaseWorkItemFormsId;
        }
        else {
            this.currentSelection = CaseWorkItemId;
            if (loadNotes) {
                const noteQueryModel = new TdoNoteQueryModel();
                noteQueryModel.parentObjectName = 'dataPatientCaseWorkItem';
                noteQueryModel.objectId = CaseWorkItemId;
                noteQueryModel.patientId = this.globals.currentPatientId;
                this.notesService.changeNoteQuery(noteQueryModel);
            }
        }

        // update toothpicker active status
        this.setTootPickerStatus();

        // send message to fees page that new case work item was selected
        // get caseworkitem by caseworkitemid
        this.messagingService.sendComponentMessage(MessagingConstants.CASE_VIEW_ITEM_CHANGED_EVENT, { doctorId: this.currentCaseWorkItem?.ProviderDoctorID });
    }
    returnFormCompletionDate(enumFormCompletionStatusID: string, statusOn: Date) {
        if (enumFormCompletionStatusID === null) {
            return '';
        }
        else if (enumFormCompletionStatusID === this.formsGlobals.STATUS_COMPLETED || enumFormCompletionStatusID === this.formsGlobals.STATUS_COMPLETEDANDSIGNED) {
            return statusOn;
        }
        else {
            return '';
        }
    }

    returnFormFilledByIcon(enumFormFilledByID: string, todo: number) {
        let statusIcon = '';
        let description = '';
        let returnString = '';
        if (this.enumCaseItemFormFilledBy) {
            if (enumFormFilledByID) {
                var item = this.enumCaseItemFormFilledBy.find(a => a.ValidValueItemId === enumFormFilledByID);
                if (item) {
                    statusIcon = item.IconIDSVG;
                    description = item.ItemDisplayValue;
                }
            }
            else {
                // get 'any' icon
                var item = this.enumCaseItemFormFilledBy.find(a => a.ItemDisplayValue.toLowerCase() === 'any');
                if (item) {
                    statusIcon = item.IconIDSVG;
                    description = item.ItemDisplayValue;
                }
            }

            if (todo === 1) {
                returnString = statusIcon;
            }
            else {
                returnString = 'To be completed by: ' + description;
            }
        }
        return returnString;
    }

    returnFormFilledByIconPreload(enumFormFilledByID: string) {
        let statusIcon = '';
        let description = '';
        let returnStrings: string[] = [];

        if (this.enumCaseItemFormFilledBy) {
            if (enumFormFilledByID) {
                var item = this.enumCaseItemFormFilledBy.find(a => a.ValidValueItemId === enumFormFilledByID);
                if (item) {
                    statusIcon = item.IconIDSVG;
                    description = item.ItemDisplayValue;
                }
            }
            else {
                // get 'any' icon
                var item = this.enumCaseItemFormFilledBy.find(a => a.ItemDisplayValue.toLowerCase() === 'any');
                if (item) {
                    statusIcon = item.IconIDSVG;
                    description = item.ItemDisplayValue;
                }
            }

            returnStrings = [`To be completed by: ${description}`, statusIcon];
        }

        return returnStrings;
    }

    returnCaseStatusIcon(enumCaseWorkItemStatus: string, todo: number) {
        let statusIcon = '';
        let description = '';
        let returnString = '';

        if (enumCaseWorkItemStatus === CaseWorkItemStatusEnum.Completed) {
            statusIcon = 'check_circle';
            description = 'Completed';
        }
        else if (enumCaseWorkItemStatus === CaseWorkItemStatusEnum.Pending) {
            statusIcon = 'pending_actions';
            description = 'Pending';
        }
        else if (enumCaseWorkItemStatus === CaseWorkItemStatusEnum.Canceled) {
            statusIcon = 'not_interested';
            description = 'Canceled';
        }
        else if (enumCaseWorkItemStatus === CaseWorkItemStatusEnum.Hold) {
            statusIcon = 'pause_circle';
            description = 'On Hold';
        }
        else if (enumCaseWorkItemStatus === CaseWorkItemStatusEnum.InProgress) {
            statusIcon = 'loop';
            description = 'In Progress';
        }

        if (todo === 1) {
            returnString = statusIcon;
        }
        else {
            returnString = description;
        }

        return returnString;
    }

    getCaseStatusDot(enumCaseWorkItemStatus: string): 'complete' | 'in-progress' | 'not-started' | 'none' {
        if (enumCaseWorkItemStatus === CaseWorkItemStatusEnum.Completed) return 'complete';
        if (enumCaseWorkItemStatus === CaseWorkItemStatusEnum.InProgress) return 'in-progress';
        if (enumCaseWorkItemStatus === CaseWorkItemStatusEnum.Pending) return 'not-started';
        if (enumCaseWorkItemStatus === CaseWorkItemStatusEnum.Hold) return 'in-progress';
        if (enumCaseWorkItemStatus === CaseWorkItemStatusEnum.Canceled) return 'none';
        return 'none';
    }

    getFormStatusDot(form: any): 'complete' | 'in-progress' | 'not-started' | 'none' {
        const tooltip = form.formCompletionStatusTooltip?.toLowerCase() || '';

        if (tooltip.includes('complete') || tooltip.includes('signed')) return 'complete';
        if (tooltip.includes('pending') || tooltip.includes('not')) return 'not-started';
        if (tooltip.includes('progress') || tooltip.includes('started')) return 'in-progress';
        return 'not-started';
    }

    updateItemStatus() {
        // update form and case status if necessary
        const form = this.returnSelectedCaseWorkItemForm();
        const item = this.returnSelectedCaseWorkItem();

        if (!form || !item) {
            return false;
        }

        if (form.enumFormCompletionStatusID === null) {
            form.enumFormCompletionStatusID = '';
        }

        if (item.enumCaseWorkItemStatusID === null) {
            item.enumCaseWorkItemStatusID = '';
        }

        if (form.enumFormCompletionStatusID === this.formsGlobals.STATUS_NOT_STARTED || item.enumCaseWorkItemStatusID === this.caseWorkItemStatusPending) {

            this.isLoading = true;

            if (form.enumFormCompletionStatusID === this.formsGlobals.STATUS_NOT_STARTED && item.enumCaseWorkItemStatusID === this.caseWorkItemStatusPending) {
                this.caseService.setCaseWorkItemAndFormToStarted(this.currentCaseWorkItemID, this.currentCaseWorkItemFormID)
                    .subscribe((response: any) => {

                        // update local status
                        this.caseWorkItems.forEach(a => {
                            if (a.CaseWorkItemId === this.currentCaseWorkItemID) {
                                a.enumCaseWorkItemStatusID = this.caseWorkItemStatusInProgress;

                                a.dataPatientCaseItemForms.forEach(b => {
                                    if (b.CaseWorkItemFormsId === this.currentCaseWorkItemFormID) {
                                        b.enumFormCompletionStatusID = this.formsGlobals.STATUS_STARTED; // this.formStatusStarted;
                                    }
                                });
                            }
                        });

                    }, err => {
                        this.showMessage('Error', 'Problem updating procedure and form status');
                    });
            }
            else if (form.enumFormCompletionStatusID === this.formsGlobals.STATUS_NOT_STARTED) {// } this.formStatusNotStarted) {
                // api call to set Started status
                this.caseService.setCaseWorkItemFormToStarted(this.currentCaseWorkItemFormID)
                    .subscribe((response: any) => {

                        // update local status
                        this.caseWorkItems.forEach(a => {
                            if (a.CaseWorkItemId === this.currentCaseWorkItemID) {
                                a.dataPatientCaseItemForms.forEach(b => {
                                    if (b.CaseWorkItemFormsId === this.currentCaseWorkItemFormID) {
                                        b.enumFormCompletionStatusID = this.formsGlobals.STATUS_STARTED; // this.formStatusStarted;
                                    }
                                });
                            }
                        });
                    }, err => {
                        this.showMessage('Error', 'Problem updating form status');
                    });
            }
            else if (item.enumCaseWorkItemStatusID === this.caseWorkItemStatusPending) {
                // api call to set In Progress status
                this.caseService.setCaseWorkItemToInProgress(this.currentCaseWorkItemID)
                    .subscribe((response: any) => {

                        // update local status
                        this.caseWorkItems.forEach(a => {
                            if (a.CaseWorkItemId === this.currentCaseWorkItemID) {
                                a.enumCaseWorkItemStatusID = this.caseWorkItemStatusInProgress;
                            }
                        });
                    }, err => {
                        this.showMessage('Error', 'Problem updating procedure status');
                    });
            }
            this.isLoading = false;
            this.cdr.detectChanges();
        }
    }

    loadForm(caseWorkItemFormsId: string, EnumCustomFormId: string, form: PatientCaseWorkItemFormDataModel) {
        if (this.router.url !== '/landing/case-view') {
            this.router.navigateByUrl('/landing/case-view').then(() => {
                //
                setTimeout(() => {
                    this.loadFormAfterRouteCheck(caseWorkItemFormsId, EnumCustomFormId, form);
                }, 100);
            });
        } else {
            this.loadFormAfterRouteCheck(caseWorkItemFormsId, EnumCustomFormId, form);
        }
        this.updateCaseStatus(caseWorkItemFormsId, form.CaseWorkItemId);
    }

    loadFormAfterRouteCheck(caseWorkItemFormsId: string, EnumCustomFormId: string, form: PatientCaseWorkItemFormDataModel) {
        // also pass in enumCustomFormID, and if form is custom then need to run appropriate component
        this.currentCaseWorkItem = this.caseWorkItems.find(p => p.CaseWorkItemId === form?.CaseWorkItemId);
        this.globals.currentPatientCaseWorkItemFormsID = caseWorkItemFormsId;
        this.messagingService.sendComponentMessage(MessagingConstants.FORM_EDIT_START, {
            caseWorkItem: this.currentCaseWorkItem,
            CaseWorkItemFormsId: caseWorkItemFormsId,
            enumCustomFormId: EnumCustomFormId,
            form
        });

        if (caseWorkItemFormsId && !EnumCustomFormId) {
            const noteQueryModel = new TdoNoteQueryModel();
            noteQueryModel.parentObjectName = 'dataPatientCaseWorkItemForms';
            noteQueryModel.objectId = caseWorkItemFormsId;
            noteQueryModel.patientId = this.globals.currentPatientId;
            this.notesService.changeNoteQuery(noteQueryModel);
        }
    }

    updateCaseStatus(caseWorkItemFormsId: string, CaseWorkItemId: string) {
        this.caseService.updateCaseViewStatusByforms(caseWorkItemFormsId, CaseWorkItemId)
            .subscribe((response: any) => {
                if (response) {
                    this.messagingService.sendComponentMessage(MessagingConstants.ONLY_CASES_STATUS_REFRESH, { PatientCaseId: this.globals.currentPatientCaseId });
                }
            });

    }

    returnToothList(teeth: DataPatientCaseWorkItemToothModel[]) {
        let list = '';

        const uniqueTeeth: string[] = [];
        for (const t of teeth) {
            if (!uniqueTeeth.includes(t.Notation)) {
                uniqueTeeth.push(t.Notation);
            }
        }

        if (uniqueTeeth) {
            if (uniqueTeeth.length) {
                uniqueTeeth.forEach(a => {
                    list += a + ', ';
                });

                // remove last comma
                list = list.slice(0, -2);
            }
        }

        return list;
    }

    returnToothListForForm(teeth: DataPatientCaseWorkItemFormToothModel[]) {
        let list = '';
        if (teeth) {
            if (teeth.length) {
                teeth.forEach(a => {
                    list = list + a.Notation + ', ';
                });

                // remove last comma
                list = list.slice(0, -2);
            }
        }

        return list;
    }

    async loadData(isOpenFirstForm: boolean = true, retryTimeout: boolean = false, loadMedicalHistory: boolean = false) {

        this.CaseInfo = null;

        // isActivelyLoadingCaseData guards the async DB calls below; isDataLoadingLoop guards the retry loop phase
        if ((this.isDataLoadingLoop && !retryTimeout) || this.isActivelyLoadingCaseData || !this.authenticationService.isLoggedIn()) {
            return;
        }

        // Cancel any stale retry ONLY after the guard passes — a blocked call must not cancel
        // the active retry or isDataLoadingLoop will be stuck true with no way to resolve it.
        if (this.loadDataRetryTimer) {
            clearTimeout(this.loadDataRetryTimer);
            this.loadDataRetryTimer = null;
        }

        this.isDataLoadingLoop = true;
        this.isLoading = true;
        if (!this.dataLoaded) {
            if (!this.isLoadingInitialData) {
                this.loadInitialData();
            }
            const currentCaseId = this.globals.currentPatientCaseId; // Store the current case ID
            this.loadDataRetryTimer = setTimeout(() => {
                this.loadDataRetryTimer = null;
                // Only retry if the case ID hasn't changed
                if (this.globals.currentPatientCaseId === currentCaseId) {
                    this.loadData(isOpenFirstForm, true);
                }
            }, 200);
            return;
        }
        this.isDataLoadingLoop = false;
        this.isActivelyLoadingCaseData = true; // prevent concurrent re-entry while awaiting DB calls
        try {

            // load patient forms list
            await this.reloadPatientForms();

            this.medicalHistoryService.getPatientMedicalAlerts(this.globals.currentPatientId).subscribe(res => {
                const alerts = res;
                const shouldLoadMedicalHistory = loadMedicalHistory;
                setTimeout(() => {
                    this.patientMedicalAlerts = alerts;
                    this.hasCriticalMedicalAlerts = this.computeHasCriticalMedicalAlerts(alerts);
                    this.cdr.markForCheck();
                    if (shouldLoadMedicalHistory) {
                        const preventAutoPopup = localStorage.getItem('preventMedicalHistoryAutoPopup' + this.localStorageService.currentUserData.authdata.userid);
                        if (preventAutoPopup !== 'true' && this.hasCriticalMedicalAlerts && this.isCheckin) {
                            this.openMedicalHistory();
                        }
                    }
                }, 0);
            });

            // Check if we have a valid patientCaseId before proceeding
            if (!this.globals.currentPatientCaseId || this.globals.currentPatientCaseId === 'null' || this.globals.currentPatientCaseId === 'undefined') {
                this.isShowPatientForms = true;
                this.caseWorkItems = [];
                this.isLoading = false;
                this.cdr.detectChanges();
                if (isOpenFirstForm) {
                    if ( this.caseWorkItemsPatientForms?.length) 
                        this.onPatientFormClick(this.caseWorkItemsPatientForms?.[0]);
                    else{
                        this.globals.currentPatientCaseWorkItemFormsID = null;
                        this.loadFormAfterRouteCheck(null, null, null);
                    }
                }
                return;
            }

            if (this.globals.currentPatientCaseId && this.globals.currentPatientCaseId !== 'null') {
                this.caseService.getCurrentPatientCaseInfo(this.globals.currentPatientCaseId).subscribe(res => {
                    this.CaseInfo = res;
                    this.cdr.detectChanges();
                });

                this.caseWorkItems = [];
                const data = await firstValueFrom(this.caseService.getCaseWorkItemsByPatientCaseID(this.globals.currentPatientCaseId));
                this.caseWorkItems = data.map(caseWorkItem => ({ ...caseWorkItem, ProviderDoctor: this.returnLocationDoctorByContactID(caseWorkItem.ProviderDoctorContactID) }));
                for (const item of this.caseWorkItems) {
                    for (const form of item.dataPatientCaseItemForms) {
                        const iconInfo: string[] = this.returnFormFilledByIconPreload(form.enumFormFilledByID);
                        form.formFilledIcon = iconInfo[1];
                        form.formFilledTooltip = iconInfo[0];
                        const statusIcon = this.enumCaseItemFormStatus.find(a => a.ValidValueItemId === form.enumFormCompletionStatusID);
                        form.formCompletionStatusIcon = statusIcon?.IconIDSVG || '';
                        form.formCompletionStatusTooltip = statusIcon?.ItemDisplayValue || 'pending';
                        form.toothList = this.returnToothListForForm(form.dataPatientCaseItemFormTeeth);
                    }
                }
                this.isLoading = false;
                this.cdr.detectChanges();
                if (this.currentSectionSelection === 0){
                    if ( this.caseWorkItemsPatientForms?.length) 
                        this.onPatientFormClick(this.caseWorkItemsPatientForms?.[0]);
                    else{
                        this.globals.currentPatientCaseWorkItemFormsID = null;
                        this.loadFormAfterRouteCheck(null, null, null);
                    }
                }
                // load first form
                else if (data.length) {
                    if (isOpenFirstForm){
                        data.every(a => {
                            if (a.dataPatientCaseItemForms) {
                                if (a.dataPatientCaseItemForms.length) {
                                    if (a.dataPatientCaseItemForms[0].CaseWorkItemFormsId) {
                                        if (isOpenFirstForm) {
                                            //this.updateItemStatus();
                                            this.onFormItemClick(a.dataPatientCaseItemForms[0], a);
                                        } else {
                                            this.isLoading = false;
                                            this.cdr.detectChanges();
                                        }
                                        return false;
                                    }
                                }
                            }
                            return true;
                        });
                    }
                    else if (this.selectedDFormId) {
                        const selectedWI = data.find(c => c.dataPatientCaseItemForms.some(f => f.DFormId === this.selectedDFormId));
                        if (selectedWI) {
                            const selectedForm = selectedWI.dataPatientCaseItemForms.find(f => f.DFormId === this.selectedDFormId);
                            if (selectedForm) {
                                this.onFormItemClick(selectedForm, selectedWI);
                            }
                        }
                    }
                }
                this.isLoading = false;
                this.cdr.detectChanges();
            } else {
                this.caseWorkItems = [];
                this.isLoading = false;
                this.cdr.detectChanges();
            }
        } finally {
            this.isActivelyLoadingCaseData = false;
        }
    }

    returnCurrentCaseProcedureName() {
        if (this.currentCaseWorkItemID) {
            const item: DataPatientCaseWorkItemModel[] = this.caseWorkItems.filter(i =>
                this.currentCaseWorkItemID.toLowerCase() === i.CaseWorkItemId.toLowerCase()
            );

            if (item.length) {
                return item[0].Description;
            } else {
                return '';
            }
        } else {
            return '';
        }
    }

    openDialogAddForm() {
        if ((this.currentSelection && this.currentSectionSelection === 1) || this.currentSectionSelection === 0) {
            // open a window to add a new procedure form to this case
            const dialogRef = this.dialog.open(CaseProcedureAddFormComponent, {
                panelClass: 'dialog',
                data: {
                    CaseWorkItem: this.currentCaseWorkItem,
                    CaseWorkItemID: this.currentCaseWorkItemID,
                    CaseProcedureName: this.returnCurrentCaseProcedureName(),
                    SelectionSection: this.currentSectionSelection,
                    AddedGeneralPatientForms: this.caseWorkItemsPatientForms,
                    LOCID: this.globals.LOCID,
                    CaseWorkItemsPatientFormsCaseWorkItemID: this.caseWorkItemsPatientFormsCaseWorkItemID
                }
            });
            dialogRef.afterClosed().subscribe(result => {
                // if any forms need a tooth, then open the tooth selector
                // then, once tooth is selected, assign tooth to all forms that require a tooth and don't already have one
                if (result !== undefined && result !== true) {
                    // filter forms that require a tooth
                    const requiresTooth = result.filter(a => a.isToothRequired && a.isToothRequired === true);
                    if (requiresTooth.length > 0) {

                        // one or more forms require tooth
                        // open tooth picker
                        this.addFormToothSelection(requiresTooth);
                    }
                    else {
                        // no tooth need forms
                        this.loadData(false);
                        // loaddata already reloads the forms
                        // this.refreshPatientForms();
                    }
                }
            }, err => {
                // this.loadData();
            });
        }
    }

    private addFormToothSelection(forms: any) {
        const toothConfig = new ToothPickerConfigModel();
        toothConfig.isMultiSelect = true;
        toothConfig.selectedTeeth = [];

        const dialogRefTooth = this.dialog.open(ToothPickerComponent, {
            panelClass: 'dialog',
            data: toothConfig
        });
        dialogRefTooth.afterClosed().subscribe(resultTooth => {

            // array of teeth
            if (resultTooth) {
                const teeth: cfgTooth[] = [];
                const toothUI: ToothUiManagerModel[] = resultTooth;
                toothUI.forEach(a => {
                    teeth.push(a.toothModel);
                });

                // add selected teeth to newly added forms that need them
                let CaseProcedureFormIDs = '';
                forms.forEach((form: any) => {
                    CaseProcedureFormIDs += form.CaseProcedureFormId + '_';
                });

                // add selected teeth to newly added forms that need them
                // this.caseService.setCaseWorkItemFormTeeth(this.currentCaseWorkItemID, this.currentCaseWorkItemFormID, teeth)
                this.caseService.setCaseWorkItemFormTeethAfterFormAddition(this.currentCaseWorkItemID, CaseProcedureFormIDs, teeth)
                    .subscribe((response: any) => {
                        this.loadData();
                        this.showMessage('Success', 'Teeth updated for form');
                        this.toothService.notifyToothChange();
                    }, err => {
                        this.showMessage('Error', 'Problem updating teeth for form');
                    });
            }
            else {
                this.showMessage('Warning', 'No teeth selected for the form.');
                this.loadData();
            }

        }, err => {
            console.error('addFormToothSelection error', err);
            this.showMessage('Error', 'Problem updating teeth for form.');
        });
    }

    returnTeethForCurrentSelectedItem() {

        // get current case work item
        const caseWorkItem = this.returnSelectedCaseWorkItem();
        // const caseWorkItem: DataPatientCaseWorkItemModel[] = this.caseWorkItems.filter(a => a.CaseWorkItemId === this.currentCaseWorkItemID);
        const teeth: cfgTooth[] = [];

        if (caseWorkItem) {
            // case item or form
            if (this.currentSelection === this.currentCaseWorkItemID) {
                // case work item
                if (caseWorkItem.dataPatientCaseItemTeeth.length) {
                    caseWorkItem.dataPatientCaseItemTeeth.forEach(a => {
                        if (this.allTeeth.filter(x => x.ToothId === a.ToothID).length) {
                            teeth.push(this.allTeeth.filter(x => x.ToothId === a.ToothID)[0]);
                        }
                    });
                }
            }
            else if (this.currentSelection === this.currentCaseWorkItemFormID) {

                // if general patient forms
                if (this.currentSectionSelection === 0) {
                    const pForm = this.caseWorkItemsPatientForms.find(form => form.CaseWorkItemFormsId === this.currentCaseWorkItemFormID);
                    if (pForm && pForm.dataPatientCaseItemFormTeeth) {
                        pForm.dataPatientCaseItemFormTeeth.forEach(tooth => {
                            const toothToPush = this.allTeeth.find(x1 => x1.ToothId === tooth.ToothID);
                            if (toothToPush) {
                                teeth.push(toothToPush);
                            }
                        });
                    }
                }
                else {
                    // case work item form
                    const pForm = caseWorkItem.dataPatientCaseItemForms.find(form => form.CaseWorkItemFormsId === this.currentCaseWorkItemFormID);
                    if (pForm && pForm.dataPatientCaseItemFormTeeth) {
                        pForm.dataPatientCaseItemFormTeeth.forEach(tooth => {
                            const toothToPush = this.allTeeth.find(x1 => x1.ToothId === tooth.ToothID);
                            if (toothToPush) {
                                teeth.push(toothToPush);
                            }
                        });
                    }
                }
            }
        }

        return teeth;
    }

    openDialogEditTeeth() {
        if (this.currentSelection) {
            const toothConfig = new ToothPickerConfigModel();
            toothConfig.isMultiSelect = true;
            const teeeth: ToothConfigurationModel[] = [];
            const currentTeeth = this.returnTeethForCurrentSelectedItem();
            for (const tt of currentTeeth) {
                const toot = new ToothConfigurationModel();
                toot.ToothId = tt.ToothId;
                teeeth.push(toot);
            }
            toothConfig.selectedTeeth = teeeth;

            // open a window to add a new procedure form to this case
            const dialogRef = this.dialog.open(ToothPickerComponent, {
                panelClass: 'dialog',
                data: toothConfig
            });
            dialogRef.afterClosed().subscribe(result => {
                if (result) {
                    // array of teeth
                    const teeth: cfgTooth[] = [];
                    const toothUI: ToothUiManagerModel[] = result;
                    toothUI.forEach(a => {
                        teeth.push(a.toothModel);
                    });

                    if (this.currentSelection === this.currentCaseWorkItemID) {
                        // CaseWorkItem
                        this.caseService.setCaseWorkItemTeeth(this.currentCaseWorkItemID, teeth)
                            .subscribe((response) => {
                                this.loadData();
                                this.showMessage('Success', 'Teeth updated for procedure');
                                for (const res of response) {
                                    const uiTooth = toothUI.find(p => p.toothModel.ToothId === res.ToothID);
                                    if (uiTooth) {
                                        this.caseService.saveCaseWorkItemTeethSurfaces(res.CaseWorkItemToothId, uiTooth.selectedSurfaceIds).subscribe((surfaceRes) => {
                                            //
                                        });
                                    }
                                }
                                this.toothService.notifyToothChange();
                            }, err => {
                                this.showMessage('Error', 'Problem updating teeth for procedure');
                            });
                    } else if (this.currentSelection === this.currentCaseWorkItemFormID) {
                        // CaseWorkItemForm
                        this.caseService.setCaseWorkItemFormTeeth(this.currentCaseWorkItemID, this.currentCaseWorkItemFormID, teeth)
                            .subscribe((response) => {
                                this.loadData();
                                this.showMessage('Success', 'Teeth updated for form');
                                for (const res of response) {
                                    const uiTooth = toothUI.find(p => p.toothModel.ToothId === res.ToothID);
                                    if (uiTooth) {
                                        this.caseService.saveCaseWorkItemTeethSurfaces(res.CaseWorkItemToothId, uiTooth.selectedSurfaceIds).subscribe((surfaceRes) => {
                                            //
                                        });
                                    }
                                }
                                this.toothService.notifyToothChange();
                            }, err => {
                                this.showMessage('Error', 'Problem updating teeth for form');
                            });
                    }
                }

            }, err => {
                console.error('openDialogEditTeeth error', err);
            });
        }
    }

    returnSelectedCaseWorkItem() {
        let item: DataPatientCaseWorkItemModel = new DataPatientCaseWorkItemModel();
        if (this.currentSectionSelection === 1) {
            item = this.caseWorkItems.filter(a => a.CaseWorkItemId === this.currentCaseWorkItemID)[0];
        }
        else {
            item = this.caseWorkItemsPatientFormsCaseWorkItem;
        }
        return item;
    }

    returnSelectedCaseWorkItemForm() {
        const item = this.returnSelectedCaseWorkItem();
        let form: PatientCaseWorkItemFormDataModel;
        if (this.currentSectionSelection === 1) {
            form = item?.dataPatientCaseItemForms?.filter(a => a.CaseWorkItemFormsId === this.currentCaseWorkItemFormID)[0];
        }
        else {
            form = this.caseWorkItemsPatientForms?.filter(a => a.CaseWorkItemFormsId === this.currentCaseWorkItemFormID)[0];
        }
        return form;
    }

    setTootPickerStatus() {
        // first, make sure a selected has been made
        if (this.currentCaseWorkItemID) {

            this.allowToothPicker = false;

            // get statuses
            let EnumFormCompletionStatus = '';
            let EnumCaseWorkItemStatusID = '';
            if (this.currentCaseWorkItemFormID) {
                EnumFormCompletionStatus = this.returnSelectedCaseWorkItemForm()?.enumFormCompletionStatusID;
            }
            if (this.currentCaseWorkItemID) {
                EnumCaseWorkItemStatusID = this.returnSelectedCaseWorkItem()?.enumCaseWorkItemStatusID;
            }

            // check status
            if (this.currentSelection === this.currentCaseWorkItemFormID) {
                this.allowToothPicker = true;
                /* if (EnumFormCompletionStatus === this.formStatusNotStarted) {
          // allow tooth edit

        }*/
            }
            else if (this.currentSelection === this.currentCaseWorkItemID) {
                if (EnumCaseWorkItemStatusID !== this.caseWorkItemStatusComplete && EnumCaseWorkItemStatusID !== this.caseWorkItemStatusCancelled) {
                    // allow tooth edit
                    this.allowToothPicker = true;
                }
            }
        }
    }

    openDialogRemove() {

        // first, make sure a selected has been made
        if (this.currentSectionSelection === 0) {

            // get statuses for delete/cancel
            let EnumFormCompletionStatus = '';
            if (this.currentCaseWorkItemFormID) {
                this.caseWorkItemsPatientForms.forEach(a => {
                    if (a.CaseWorkItemFormsId === this.currentCaseWorkItemFormID) {
                        EnumFormCompletionStatus = a.enumFormCompletionStatusID;
                    }
                });
            }

            const dialogRef = this.dialog.open(CaseItemFormRemoveCancelComponent, {
                panelClass: 'dialog',
                data: {
                    CaseWorkItemID: this.caseWorkItemsPatientFormsCaseWorkItemID,
                    CaseWorkItemFormID: this.currentCaseWorkItemFormID,
                    enumFormCompletionStatus: EnumFormCompletionStatus,
                    enumCaseWorkItemStatusID: ''
                }
            });
            dialogRef.afterClosed().subscribe(result => {
                if (result === 'delete') {
                    this.deleteSelectedItem();
                }
                else if (result === 'cancel') {
                    this.cancelSelectedItem();
                }
            });
        }
        else if (this.currentCaseWorkItemID) {

            // get statuses for delete/cancel
            let EnumFormCompletionStatus = '';
            let EnumCaseWorkItemStatusID = '';
            if (this.currentCaseWorkItemFormID) {
                EnumFormCompletionStatus = this.returnSelectedCaseWorkItemForm()?.enumFormCompletionStatusID;
            }
            if (this.currentCaseWorkItemID) {
                EnumCaseWorkItemStatusID = this.returnSelectedCaseWorkItem()?.enumCaseWorkItemStatusID;
            }

            const dialogRef = this.dialog.open(CaseItemFormRemoveCancelComponent, {
                panelClass: 'dialog',
                data: {
                    CaseWorkItemID: this.currentCaseWorkItemID,
                    CaseWorkItemFormID: this.currentCaseWorkItemFormID,
                    enumFormCompletionStatus: EnumFormCompletionStatus,
                    enumCaseWorkItemStatusID: EnumCaseWorkItemStatusID
                }
            });
            dialogRef.afterClosed().subscribe(result => {

                if (result === 'delete') {
                    this.deleteSelectedItem();
                }
                else if (result === 'cancel') {
                    this.cancelSelectedItem();
                }
                else {
                    //
                }
            });
        }
    }


    deleteSelectedItem() {
        this.isLoading = true;
        // case item or form
        if (this.currentSelection === this.currentCaseWorkItemID) {
            // case work item selected
            this.caseService.deleteCaseWorkItem(this.currentCaseWorkItemID)
                .subscribe((response: any) => {
                    this.selectedDFormId = null;
                    this.loadData();
                    this.showMessage('Success', 'Procedure deleted');
                }, err => {
                    this.showMessage('Error', 'Problem deleting procedure');
                });
        }
        else if (this.currentSelection === this.currentCaseWorkItemFormID) {
            // case work item form selected
            this.caseService.deleteCaseWorkItemForm(this.currentCaseWorkItemFormID)
                .subscribe((response: any) => {
                    this.caseService.deleteCaseWorkItemFormTeeth(this.currentCaseWorkItemFormID)
                        .subscribe((response: any) => {
                            this.selectedDFormId = null;
                            this.loadData(true);
                            // loaddata already reloads the forms
                            // this.refreshPatientForms();
                            this.showMessage('Success', 'Procedure form deleted');

                        }, err => {
                            this.showMessage('Error', 'Problem deleting procedure form');
                        });
                }, err => {
                    this.showMessage('Error', 'Problem deleting procedure form');
                });
        }
    }

    cancelSelectedItem() {
        this.isLoading = true;

        // case item or form
        if (this.currentSelection === this.currentCaseWorkItemID) {
            // case work item selected
            this.caseService.setCaseWorkItemToCanceled(this.currentCaseWorkItemID)
                .subscribe((response: any) => {
                    this.loadData();
                    this.showMessage('Success', 'Procedure canceled');
                }, err => {
                    this.showMessage('Error', 'Problem canceling procedure');
                });
        }
        else if (this.currentSelection === this.currentCaseWorkItemFormID) {
            // case work item form selected
            this.caseService.setCaseWorkItemFormToCanceled(this.currentCaseWorkItemFormID)
                .subscribe((response: any) => {
                    this.loadData();
                    // loaddata already reloads the forms
                    // this.refreshPatientForms();
                    this.showMessage('Success', 'Procedure form canceled');
                }, err => {
                    this.showMessage('Error', 'Problem canceling procedure form');
                });
        }
    }

    toggleMoreContent() {
        this.showMoreCaseOptions = !this.showMoreCaseOptions;
    }

    processMoreOptionsEvent(option) {

        this.showMoreCaseOptions = false;

        if (option === 0) {
            // show success
            this.closeCase();
        }

        if (option === 1) {
            // open Bill Functionality form
            this.openDialogCaseBillFunctionality();

        }

        if (option === 2) {
            // open Check out
            this.onCheckOutPatient();

        }
    }

    onCheckOutPatient() {
        const today: Date = new Date();
        const LocalTodayDateRange = new DateRangeModel(today, today);

        this.schedulingService.getAppointmentIdByPatientId(this.globals.currentPatientId, LocalTodayDateRange.toString()).subscribe({
            next: (dataC) => {
                this.appointment = dataC;
                if (!this.appointment) {
                    return;
                }
                localStorage.setItem('selectedAppt', JSON.stringify(this.appointment));
                this.router.navigateByUrl('landing/notes-to-front');
                this.requestCheckOut.emit();
                this.caseService.stopAllTimerWatchByPatientCaseId(dataC.PatientCaseId).toPromise();
                // console.log('CaseViewComponent onCheckOutPatient sendComponentMessage CASES_REFRESH');
                this.messagingService.sendComponentMessage(MessagingConstants.CASES_REFRESH, {});
            },
            error: (error) => {
                console.error('getAppointmentIdByPatientId error:', error);
            }
        });
    }

    closeCase() {
        const payload = new CreateTransactionItemModel();
        payload.PatientId = this.globals.currentPatientId;
        payload.PatientCaseId = this.globals.currentPatientCaseId;
        payload.LOCID = parseInt(localStorage.getItem('LOCID'));

        this.isLoading = true;
        this.arService.closeCase(payload)
            .subscribe((response: any) => {
                this.showMessage('Success', 'Case completed');
                this.loadData();
            }, err => {
                this.showMessage('Error', 'Problem completing case');
                this.isLoading = false;
                this.cdr.detectChanges();
            });
    }

    createTransactionForCase() {
        const payload = new CreateTransactionItemModel();
        payload.PatientId = this.globals.currentPatientId;
        payload.PatientCaseId = this.globals.currentPatientCaseId;
        payload.LOCID = parseInt(localStorage.getItem('LOCID'));

        this.isLoading = true;
        this.arService.closeCase(payload)
            .subscribe((response: any) => {
                this.showMessage('Success', 'Case completed');

                // redirect to fees page
                this.isLoading = false;
                // No need to set globals.currentPatientCaseId as it's already the source of truth
                this.router.navigateByUrl('/landing/fees');
            }, err => {
                this.showMessage('Error', 'Problem completing case');
                this.isLoading = false;
            });
    }

    showMessage(type, message) {
        this.uiService.displayMessage(type, message);
    }

    openDialogAddProcedure(e) {
        // open a window to add a new procedure to this case
        const dialogRef = this.dialog.open(CaseAddProcedureComponent, {
            panelClass: 'dialog',
            width: '800px',
            height: '650px',
            maxHeight: '90vh',
            data: {
                PatientCaseId: this.globals.currentPatientCaseId,
                isSingleSelection: false
            }
        });
        dialogRef.afterClosed().subscribe(result => {
            if (result !== undefined && result !== false) { this.loadData(); }
        }, err => {
            this.loadData();
        });
    }

    openDialogCaseBillFunctionality() {
        // open a window to add a new procedure to this case
        const dialogRef = this.dialog.open(CaseBillFunctionalityComponent, {
            panelClass: 'dialog',
            data: {
                PatientCaseId: this.globals.currentPatientCaseId,
            }
        });
        dialogRef.afterClosed().subscribe(result => {
            if (result !== undefined && result !== false)
            // close case, then send to fees page
            // this.createTransactionForCase();
            { this.router.navigateByUrl('/landing/fees'); }
        }, err => {
            // close case, then send to fees page
            // this.createTransactionForCase();
            this.showMessage('Error', 'Something went wrong');
        });
    }

    // async refreshPatientForms() {
    //     this.isLoadingPatientForms = true;
    //     this.caseWorkItemsPatientForms = [];
    //     // get current patient forms
    //     const promises: any[] = [
    //         this.caseService.getPatientForms(this.globals.currentPatientId).toPromise(), // general patient forms
    //     ];

    //     try {
    //         const results: any[] = await Promise.all(promises);

    //         if (results) {
    //             this.caseWorkItemsPatientForms = results[0];
    //             if (!this.caseWorkItemsPatientForms) {
    //                 this.caseWorkItemsPatientForms = [];
    //             }
    //         }
    //         this.isLoadingPatientForms = false;
    //         this.cdr.detectChanges();
    //     } catch (err) {
    //         this.isLoading = false;
    //         this.showMessage('Error', 'Error refreshing patient forms');
    //         this.cdr.detectChanges();
    //     }
    // }

    onFormItemClick(form: PatientCaseWorkItemFormDataModel, item: DataPatientCaseWorkItemModel) {
        this.currentCaseWorkItemID = item.CaseWorkItemId;
        this.currentSectionSelection = 1;
        this.selectedDFormId = form.DFormId;
        if (form && (form.isToothRequired && form.dataPatientCaseItemFormTeeth.length === 0)) {
            this.dialogService.openToothPicker(false).subscribe((response) => {
                if (response) {
                    const teeth: cfgTooth[] = [];
                    const toothUI: ToothUiManagerModel[] = response;
                    toothUI.forEach(a => {
                        teeth.push(a.toothModel);
                    });

                    // add selected teeth to newly added forms that need them
                    // this.caseService.setCaseWorkItemFormTeeth(this.currentCaseWorkItemID, this.currentCaseWorkItemFormID, teeth)
                    this.caseService.setCaseWorkItemFormTeeth(item.CaseWorkItemId, form.CaseWorkItemFormsId, teeth)
                        .subscribe(async (response1) => {
                            await this.loadData();
                            this.loadForm(form.CaseWorkItemFormsId, form.enumCustomFormID, form);
                            this.currentCaseWorkItemFormID = form.CaseWorkItemFormsId;
                            this.currentCaseWorkItemID = item.CaseWorkItemId;
                            this.updateItemStatus();
                            this.setCurrentSelections(item.CaseWorkItemId, form.CaseWorkItemFormsId, false);
                            this.showMessage('Success', 'Teeth updated for form');
                            for (const res of response) {
                                const uiTooth = toothUI.find(p => p.toothModel.ToothId === res.ToothID);
                                if (uiTooth) {
                                    this.caseService.saveCaseWorkItemTeethSurfaces(res.CaseWorkItemToothId, uiTooth.selectedSurfaceIds).subscribe((surfaceRes) => {
                                        //
                                    });
                                }
                            }
                            this.toothService.notifyToothChange();
                        }, err => {
                            this.showMessage('Error', 'Problem updating teeth for form');
                        });
                }
            }, err => {
                // this.loadData();
            });
        } else {
            this.loadForm(form.CaseWorkItemFormsId, form.enumCustomFormID, form);

            // if (this.currentCaseWorkItemFormID != form.CaseWorkItemFormsId && this.currentCaseWorkItemID != item.CaseWorkItemId) {
            this.currentCaseWorkItemFormID = form.CaseWorkItemFormsId;
            this.currentCaseWorkItemID = item.CaseWorkItemId;
            this.updateItemStatus();
            this.setCurrentSelections(item.CaseWorkItemId, form.CaseWorkItemFormsId, false);
            // }
        }
    }

    saveDoctorSelection(CaseWorkItemId, event) {
        alert('blah');
    }

    timerAction(WorkItemEventID: string, CaseWorkItemId: string, LOCID: number, start: boolean, stop: boolean) {
        const eventModel = new PassedPatientCaseWorkItemEventModel();
        eventModel.WorkItemEventID = WorkItemEventID;
        eventModel.CaseWorkItemID = CaseWorkItemId;
        eventModel.LOCID = LOCID;
        eventModel.StartTimer = start;
        eventModel.StopTimer = stop;
        const cwi = this.caseWorkItems.find(p => p.CaseWorkItemId === CaseWorkItemId);

        // if user is a dr, set dr (only when starting the timer -- stopping should not reassign the doctor)
        // console.log('timerAction: userIsDoctor: ', this.userIsDoctor);
        if (start) {
            if (this.userIsDoctor) {
                if (!cwi.ProviderDoctorID) {
                    const userId = this.localStorageService.currentUserData.authdata.userid;
                    const doctor = this.locationDoctors.find(a => a.UserId === userId);
                    if (doctor) {
                        // console.log('timerAction: doctor User: ', doctor);
                        if (cwi) {
                            cwi.ProviderDoctorContactID = doctor.ContactId;
                            cwi.ProviderDoctorID = doctor.DoctorId;
                            // set dr object to cwi
                            cwi.ProviderDoctor = doctor;

                            this.setActiveProviderDoctorContext(doctor);

                        }
                        eventModel.ProviderDoctorContactID = doctor.ContactId;
                        eventModel.ProviderDoctorID = doctor.DoctorId;
                    }
                } else {
                    // a doctor is already assigned to this procedure (e.g. via case-level cascade) -- don't reassign it to whoever starts the timer
                    eventModel.ProviderDoctorContactID = cwi.ProviderDoctorContactID;
                    eventModel.ProviderDoctorID = cwi.ProviderDoctorID;

                    const doc = this.locationDoctors.find(a => a.DoctorId === cwi.ProviderDoctorID);
                    this.setActiveProviderDoctorContext(doc);
                }
            } else {
                // console.log('timerAction: cwi.ProviderDoctorID: ', cwi.ProviderDoctorID);
                if (cwi.ProviderDoctorID) {
                    const doc = this.locationDoctors.find(a => a.DoctorId === cwi.ProviderDoctorID);
                    if (doc) {
                        eventModel.ProviderDoctorContactID = doc.ContactId;
                        eventModel.ProviderDoctorID = doc.DoctorId;
                        if (cwi) {
                            // set dr object to cwi
                            cwi.ProviderDoctor = doc;
                            this.setActiveProviderDoctorContext(doc);
                        }
                    }
                }
                else {
                    // console.log('timerAction: this.activeLocationDoctors[0]: ', this.activeLocationDoctors[0]);
                    const doc = this.activeLocationDoctors[0];
                    if (doc) {
                        eventModel.ProviderDoctorContactID = doc.ContactId;
                        eventModel.ProviderDoctorID = doc.DoctorId;
                        if (cwi) {
                            // set dr object to cwi
                            cwi.ProviderDoctor = doc;
                            cwi.ProviderDoctorID = doc.DoctorId;
                        }
                        this.setActiveProviderDoctorContext(doc);
                    } else {
                        this.showMessage('Error', 'No active doctor available to start the timer. Please assign a doctor first.');
                        return;
                    }
                }
            }
        } else {
            // stopping the timer should not reassign the doctor -- report the already-assigned doctor back to the API
            eventModel.ProviderDoctorContactID = cwi?.ProviderDoctorContactID ?? '';
            eventModel.ProviderDoctorID = cwi?.ProviderDoctorID ?? '';
        }


        if (start) {
            this.schedulingService.SetSeatedStatus(cwi.PatientCaseId)
                .subscribe((surfaceRes) => {
                    //
                });
        }

        // post obj
        this.caseService.handleCaseWorkItemEvent(eventModel)
            .subscribe({
                next: (response: DataPatientCaseWorkItemEventModel) => {
                    if (start) {
                        this.showMessage('Success', 'Timer Started');
                    }
                    else if (stop) {
                        this.showMessage('Success', 'Timer Stopped');
                        this.globals.currentPatientCaseWorkItemEventID = '';
                    }

                    // update local case work item
                    const CaseWorkItem = this.caseWorkItems.find(a => a.CaseWorkItemId === CaseWorkItemId);
                    if (CaseWorkItem) {
                        CaseWorkItem.EventDateStart = response.EventDateStart;
                        CaseWorkItem.WorkItemEventID = response.WorkItemEventId;
                        CaseWorkItem.ProviderDoctorContactID = eventModel?.ProviderDoctorContactID;
                        this.localStorageService.practicingDoctorId = eventModel?.ProviderDoctorID;
                        if (stop) {
                            CaseWorkItem.EventDateStart = null;
                            CaseWorkItem.WorkItemEventID = null;
                            this.localStorageService.practicingDoctorId = null;
                        }
                    }
                    // console.log('CaseViewComponent timerAction sendComponentMessage CASES_REFRESH');
                    this.messagingService.sendComponentMessage(MessagingConstants.CASE_FORMS_REFRESH, {});
                },
                error: (err) => {
                    this.showMessage('Error', 'There was an issue with the timer.');
                }
            });
    }

    timerDoctorAction(WorkItemEventID: string, CaseWorkItemId: string, event: TdoDropdownChange) {
        if (event.isUserInput) {
            const CaseWorkItem = this.caseWorkItems.find(a => a.CaseWorkItemId === CaseWorkItemId);
            if (!event.value || (!event.isUserInput && CaseWorkItem.EventDateStart === null)) {
                return;
            }
            this.setActiveDoctor(event.value, WorkItemEventID, CaseWorkItem, true);
        }
    }

    getDoctorDropdownOptions(caseWorkItem: DataPatientCaseWorkItemModel): DoctorByTDOCIDModel[] {
        const assignedId = caseWorkItem?.ProviderDoctorID?.toLowerCase();
        if (!assignedId || this.activeLocationDoctors.some(d => d.DoctorId?.toLowerCase() === assignedId)) {
            return this.activeLocationDoctors;
        }
        const cached = this.doctorDropdownOptionsCache.get(caseWorkItem.CaseWorkItemId);
        if (cached?.assignedId === assignedId && cached.baseline === this.activeLocationDoctors) {
            return cached.options;
        }
        const inactiveAssigned = this.locationDoctors.find(d => d.DoctorId?.toLowerCase() === assignedId);
        const options = inactiveAssigned ? [...this.activeLocationDoctors, inactiveAssigned] : this.activeLocationDoctors;
        this.doctorDropdownOptionsCache.set(caseWorkItem.CaseWorkItemId, { assignedId, baseline: this.activeLocationDoctors, options });
        return options;
    }

    returnLocationDoctorByContactID(contactID: string) {
        let returnContact: DoctorByTDOCIDModel = new DoctorByTDOCIDModel();

        if (this.locationDoctors && this.locationDoctors.length > 0) {
            returnContact = this.locationDoctors.find(a => a.ContactId === contactID);
            if (returnContact) {
                return returnContact;
            }
        }
        return null;
    }




    /**
     * Sets the complete active-provider identity atomically, so no caller leaves
     * currentProviderDoctorContactID/UserID stale relative to currentProviderDoctorID/FullName.
     */
    private setActiveProviderDoctorContext(doc: DoctorByTDOCIDModel | undefined | null) {
        if (!doc) {
            return;
        }
        this.localStorageService.practicingDoctorId = doc.DoctorId;
        this.globals.currentProviderDoctorID = doc.DoctorId;
        this.globals.currentProviderDoctorFullName = doc.FullName;
        this.globals.currentProviderDoctorContactID = doc.ContactId;
        this.globals.currentProviderDoctorUserID = doc.UserId;
    }

    private setActiveDoctor(providerDoctor: DoctorByTDOCIDModel, WorkItemEventID: string, CaseWorkItem: DataPatientCaseWorkItemModel, startTimer: boolean = false) {
        // console.log('setActiveDoctor: providerDoctor: ', providerDoctor);
        if (!providerDoctor) {
            // console.error('CaseViewComponent setActiveDoctor: no provider doctor');
            return;
        }
        // console.log('CaseViewComponent setActiveDoctor: providerDoctor: ', providerDoctor);
        this.setActiveProviderDoctorContext(providerDoctor);

        this.messagingService.sendComponentMessage(MessagingConstants.DOCTOR_UPDATE, { doctorId: providerDoctor?.DoctorId });

        // post obj
        if (startTimer) {
            const eventModel = new PassedPatientCaseWorkItemEventModel();
            eventModel.WorkItemEventID = WorkItemEventID;
            eventModel.CaseWorkItemID = CaseWorkItem.CaseWorkItemId;
            eventModel.LOCID = CaseWorkItem.LOCID;
            eventModel.ProviderDoctorContactID = providerDoctor?.ContactId;

            eventModel.StartTimer = false;
            eventModel.StopTimer = false;
            eventModel.ProviderDoctorID = providerDoctor?.DoctorId;
            this.caseService.handleCaseWorkItemEvent(eventModel)
                .subscribe({
                    next: (response: DataPatientCaseWorkItemEventModel) => {

                        this.showMessage('Success', 'Doctor Selected');

                        // update local case work item
                        if (CaseWorkItem) {
                            CaseWorkItem.WorkItemEventID = response.WorkItemEventId;
                            CaseWorkItem.ProviderDoctorID = providerDoctor.DoctorId;
                            CaseWorkItem.ProviderDoctorContactID = response?.ProviderDoctorContactID;
                            CaseWorkItem.ProviderDoctor = providerDoctor;
                            CaseWorkItem.EventDateStart = response.EventDateStart;
                            this.globals.currentProviderDoctorContactID = response?.ProviderDoctorContactID;
                            this.globals.currentProviderDoctorID = providerDoctor.DoctorId;
                            this.globals.currentProviderDoctorUserID = providerDoctor.UserId;
                            this.globals.currentPatientCaseWorkItemEventID = response.WorkItemEventId;
                        }

                        // console.log('CaseViewComponent setActiveDoctor sendComponentMessage CASES_REFRESH');
                        this.messagingService.sendComponentMessage(MessagingConstants.CASE_FORMS_REFRESH, {});
                    },
                    error: (err) => {
                        this.showMessage('Error', 'There was an issue with choosing the doctor.');
                        console.error('Error: ', err);
                    }
                });
        }
    }

    isCanEdit() {
        return this.authenticationService.currentUserRolesIds.includes(UserRoleEnum.CaseMgmt);
    }

    onShowAllEventsForWorkItem(item: DataPatientCaseWorkItemModel) {
        const config = new MatDialogConfig();
        config.panelClass = 'dialog';
        config.data = { doctors: this.doctorsByTDOCID, workItem: item, selectedProcedure: item };

        this.dialog.open(CaseViewWorkItemEventsDialogComponent, config);
    }

    getFormEnumStatus(enumFormCompletionStatusID: string) {
        if (enumFormCompletionStatusID != null) {
            const enu = this.enumCaseItemFormStatus.find(p => p.ValidValueItemId.toLowerCase() === enumFormCompletionStatusID.toLowerCase());
            if (enu) {
                return enu.ItemDisplayValue;
            }
        }
        return '';
    }

    onPatientFormsDetails() {
        const config = new MatDialogConfig();
        config.panelClass = 'dialog';
        config.data = this.caseWorkItemsPatientForms;
        this.dialog.open(CaseViewPatientFormsDetailsDialogComponent, config);
    }

    onPatientFormClick(form: PatientCaseWorkItemFormDataModel) {
        if (this.currentCaseWorkItemFormID != form.CaseWorkItemFormsId) {

            if (form && (form.isToothRequired && form.dataPatientCaseItemFormTeeth.length === 0)) {
                this.dialogService.openToothPicker(false).subscribe((response) => {
                    if (response) {
                        const teeth: cfgTooth[] = [];
                        const toothUI: ToothUiManagerModel[] = response;
                        toothUI.forEach(a => {
                            teeth.push(a.toothModel);
                        });

                        // add selected teeth to newly added forms that need them
                        // this.caseService.setCaseWorkItemFormTeeth(this.currentCaseWorkItemID, this.currentCaseWorkItemFormID, teeth)
                        this.caseService.setCaseWorkItemFormTeeth(form.CaseWorkItemId, form.CaseWorkItemFormsId, teeth)
                            .subscribe(async (response1) => {
                                this.showMessage('Success', 'Teeth updated for form');
                                for (const res of response) {
                                    const uiTooth = toothUI.find(p => p.toothModel.ToothId.toLowerCase() === res.toothModel.ToothId.toLowerCase());
                                    if (uiTooth) {
                                        this.caseService.saveCaseWorkItemTeethSurfaces(response1[0].CaseWorkItemToothId, uiTooth.selectedSurfaceIds).subscribe((surfaceRes) => {
                                            //
                                        });
                                    }
                                }
                                this.currentCaseWorkItemID = this.caseWorkItemsPatientFormsCaseWorkItemID;
                                this.currentSectionSelection = 0;
                                this.loadForm(form.CaseWorkItemFormsId, form.enumCustomFormID, form);
                                this.currentCaseWorkItemFormID = form.CaseWorkItemFormsId;
                                this.updateItemStatus();
                                this.setCurrentSelections(this.caseWorkItemsPatientFormsCaseWorkItemID, form.CaseWorkItemFormsId);
                                this.reloadPatientForms();
                                this.toothService.notifyToothChange();
                            }, err => {
                                this.showMessage('Error', 'Problem updating teeth for form');
                            });
                    }
                }, err => {
                    console.error('onPatientFormClick error', err);
                });
            }
            else {
                this.currentCaseWorkItemID = this.caseWorkItemsPatientFormsCaseWorkItemID;
                this.currentSectionSelection = 0;
                this.loadForm(form.CaseWorkItemFormsId, form.enumCustomFormID, form);
                this.currentCaseWorkItemFormID = form.CaseWorkItemFormsId;
                this.updateItemStatus();
                this.setCurrentSelections(this.caseWorkItemsPatientFormsCaseWorkItemID, form.CaseWorkItemFormsId);
            }
        }
    }

    onClickCaseWorkItem(caseWorkItem: DataPatientCaseWorkItemModel) {
        const isSameCaseWorkItem = this.currentCaseWorkItemID === caseWorkItem.CaseWorkItemId;

        if (!isSameCaseWorkItem) {
            this.setCurrentSelections(caseWorkItem.CaseWorkItemId, '');
            this.currentSectionSelection = 1;
        }

        if (isSameCaseWorkItem
            && this.globals.currentProviderDoctorID?.toLowerCase() === caseWorkItem.ProviderDoctorID?.toLowerCase()) {
            return;
        }

        if (caseWorkItem.ProviderDoctorID) {
            const doc = this.locationDoctors.find(a => a.DoctorId === caseWorkItem.ProviderDoctorID);
            if (doc) {
                caseWorkItem.ProviderDoctor = doc;
            }
            this.setActiveDoctor(caseWorkItem.ProviderDoctor, caseWorkItem.WorkItemEventID, caseWorkItem);
        }
    }


    onOpenVitalSigns(event: Event): void {
        // Prevent the event from bubbling up
        event.stopPropagation();

        // Get the current selected case work item or use the first one if none selected
        const currentCaseWorkItem = this.currentCaseWorkItemID ?
            this.caseWorkItems?.find(item => item.CaseWorkItemId === this.currentCaseWorkItemID) :
            this.caseWorkItems?.[0];

        // Optional: Pass existing vital signs data if available
        const dialogData = {
            caseWorkItem: currentCaseWorkItem,
            patientId: this.globals.currentPatientId,
            caseId: currentCaseWorkItem?.CaseWorkItemId,
            patientName: this.globals.currentPatientFullName,
            existingEntries: [] // You can load existing vital signs here if stored
        };

        const dialogRef = this.dialog.open(VitalSignsDialogComponent, {
            panelClass: 'dialog',
            maxWidth: '95dvw',
            maxHeight: '95dvh',
            hasBackdrop: true,
            disableClose: false,
            autoFocus: false,
            restoreFocus: false,
            data: dialogData
        });

        dialogRef.afterClosed().subscribe((result: VitalSignsModel[]) => {
            if (result && result.length > 0) {
                // console.log('Vital signs saved for patient:', this.globals.currentPatientFullName, result);
                // Handle the saved vital signs data
                // You can save to a service, update the UI, or send to an API
                this.handleVitalSignsSaved(result, currentCaseWorkItem);
            }
        });
    }

    openReferringDoctorDetails() {
        if (!this.CaseInfo?.ReferringDoctorId) {
            console.warn('No ReferringDoctorId available');
            return;
        }

        const dialogRef = this.dialog.open(ReferringDoctorInformationComponent, {
            panelClass: 'dialog',
            width: '1000px',
            height: '700px',
            maxWidth: '95dvw',
            maxHeight: '95dvh',
            data: {
                ReferringDoctorId: this.CaseInfo.ReferringDoctorId
            }
        });
    }

    private handleVitalSignsSaved(vitalSigns: VitalSignsModel[], caseWorkItem?: DataPatientCaseWorkItemModel): void {
        // Process the vital signs data
        // This could involve:
        // - Saving to a service or API
        // - Updating the case work item
        // - Refreshing the UI
        // - Showing a success message

        const caseDescription = caseWorkItem?.Description || 'Current Patient';
        // console.log(`Saved ${vitalSigns.length} vital signs entries for: ${caseDescription}`);

        // Example: You might want to add a flag to indicate vital signs are available
        // if (caseWorkItem) {
        //     caseWorkItem.hasVitalSigns = true;
        // }

        // Example: Show success message
        // this.snackBar.open(`Vital signs saved for ${caseDescription}`, 'Success', {
        //     duration: 3000,
        //     verticalPosition: 'top'
        // });
    }
    openMedicalHistory() {
        // console.log('openMedicalHistory');
        this.dialogService.openMedicalHistory(this.globals.currentPatientId);
    }

    /**
     * Determines whether the patient has critical medical alerts that must be flagged
     * on the Case View banner. Only premedication-required and critical sensitivities
     * (Latex, Epinephrine, Antibiotics, Pregnancy) count as alerts — mirrors the determinations
     * shown in the Medical History dialog.
     */
    private computeHasCriticalMedicalAlerts(alerts: any[]): boolean {
        if (!Array.isArray(alerts) || alerts.length === 0) {
            return false;
        }

        const CRITICAL_SENSITIVITY_ITEM_NAMES = ['AllergicToLatex', 'AllergicToEpinephrine', 'AllergicToAntibiotics', 'Pregnant'];
        const PREMEDICATION_REQUIRED_ITEM_NAME = 'requiredToTakeAntibioticsAns';
        const LATEX_ALLERGY_ILLNESS = 'Latex Allergy';
        const PREVIOUS_ILLNESSES = 'PreviousIllnesses';
        const PREVIOUS_ILLNESS = 'PreviousIllness';

        const hasCriticalSensitivity = alerts.some(item => {
            if (!CRITICAL_SENSITIVITY_ITEM_NAMES.includes(item?.dataFormItemName)) {
                return false;
            }
            // Routed through the service so Checkbox ('true'), display-text ('yes') and
            // Radio/Combo List (option GUID) answers are all recognized as affirmative.
            return this.medicalHistoryService.isAffirmativeAnswer(item?.patientNote, item?.validvalueId);
        });

        const hasLatexIllness = alerts.some(item => (item?.dataFormItemName === PREVIOUS_ILLNESSES
            || item?.dataFormItemName === PREVIOUS_ILLNESS)
            && item?.problem === LATEX_ALLERGY_ILLNESS);

        const hasPremedicationRequired = alerts.some(item => item?.dataFormItemName === PREMEDICATION_REQUIRED_ITEM_NAME);

        return hasCriticalSensitivity || hasPremedicationRequired || hasLatexIllness;
    }

    onPatientFormsSectionClick() {
        this.currentSectionSelection = 0;
        this.currentCaseWorkItemID = this.caseWorkItemsPatientFormsCaseWorkItem?.CaseWorkItemId;
        this.currentCaseWorkItem = this.caseWorkItemsPatientFormsCaseWorkItem;
    }

}
